// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".account__menu{display:grid;grid-gap:calc(var(--spacing));grid-template-columns:1fr;grid-template-rows:auto}@media (min-width:48.0625em){.account__menu{grid-template-columns:repeat(3,minmax(20rem,1fr));grid-gap:calc(var(--spacing)*2)}}.account__products{border-top:1px solid var(--secondary-color-3)}.account__products .slices .slice:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
